import { HttpService } from '@/services/http.service';

export default {
    async order(order) {
        return await HttpService.httpPost('/marketing/order-marketing-materials', order);
    },

    async orderPremium(order) {
        return await HttpService.httpPost('/marketing/order-premium-materials', order);
    },

    async eventKitOrder(order) {
        return await HttpService.httpPost('/marketing/event-kit-ordering', order);
    },
}
